import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

import MobileStepper from '@material-ui/core/MobileStepper';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';

import { startEditWebsiteRoot } from 'store/actions/website';

const styles = theme => ({
  root: {

  },
  img: {
    alignSelf: 'center',
    height: '250px',
    width: '450px',
    overflow: 'hidden',
  },
});

class HeroSelect extends Component {
  constructor(props) {
    super(props);
    const { heroImages, initialFilename } = props;
    const initialIndex = heroImages.findIndex(item => item.filename === initialFilename);
    const activeStep = initialIndex >= 0 ? initialIndex : 0;

    this.state = {
      activeStep,
    };
  }

  handleNext = () => {
    const { heroImages, startEditWebsiteRoot } = this.props;

    this.setState(prevState => {
      const activeStep = prevState.activeStep + 1;
      const heroImage = heroImages[activeStep].filename;
      startEditWebsiteRoot({ heroImage });

      return ({
        activeStep,
      });
    });
  };

  handleBack = () => {
    const { heroImages, startEditWebsiteRoot } = this.props;

    this.setState(prevState => {
      const activeStep = prevState.activeStep - 1;
      const heroImage = heroImages[activeStep].filename;
      startEditWebsiteRoot({ heroImage });

      return ({
        activeStep: prevState.activeStep - 1,
      });
    });
  };

  render() {
    const {
      classes,
      theme,
      heroImages,
    } = this.props;
    const { activeStep } = this.state;
    const maxSteps = heroImages.length;
    const downloadURL = heroImages && heroImages[activeStep] ? heroImages[activeStep].downloadURL : "";
    const fileName = heroImages && heroImages[activeStep] ? heroImages[activeStep].fileName : "";

    return(
      <div>
        {downloadURL &&
          <img
            className={classes.img}
            src={downloadURL}
            alt={fileName}
          />
        }
        <MobileStepper
          steps={maxSteps}
          position="static"
          activeStep={activeStep}
          className={classes.mobileStepper}
          nextButton={
            <Button size="small" onClick={this.handleNext} disabled={activeStep === maxSteps - 1}>
              Next
              {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </Button>
          }
          backButton={
            <Button size="small" onClick={this.handleBack} disabled={activeStep === 0}>
              {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
              Back
            </Button>
          }
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  heroImages: state.heroImagesState.sort((a, b) => {
    if (a.filename < b.fileName) {
      return -1;
    } else if (a.filename > b.filename) {
      return 1;
    } else {
      return 0;
    }
  }),
});

const mapDispatchToProps = {
  startEditWebsiteRoot
};

export default compose(
  withStyles(styles, { withTheme: true }),
  connect(mapStateToProps, mapDispatchToProps),
)(HeroSelect);



// WEBPACK FOOTER //
// ./src/components/admin/Website/Main/HeroSelect.jsx